module.exports = __webpack_public_path__ + "static/media/icon-deslocamentoforadehr-cinza.6053b40e.svg";